import { NgModule } from '@angular/core';
import { AppProviderRepository } from '../0.2.provider/app.provider.repository';
import { AppProviderUtils } from '../0.2.provider/app.provider.utils';
import { AppProviderInteractor } from '../0.2.provider/app.provider.interactor';

@NgModule({
    imports:[
        AppProviderInteractor,
        AppProviderRepository,
        AppProviderUtils
    ]
})
export class AppModuleProvider { }